import React,{useState, useEffect}  from 'react';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cscontrolstruct(){

    const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
        <Sides/>
        <Helmet>
 
 <title>C# control Structure tutorial For Beginners</title>
 <meta name="description" content="C# control Structure tutorial for beginners.control Structure in C# is a program is executed as per requirement according to requirement the sequence can be changed by using the control structure statementr provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# control Structure,c# control Structure for,c sharp control Structure,c# control Structure for loop,end for loop c#,c# exit for loop,exit while loop c#,control Structure foreach c#,c# foreach control Structure" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-control-structure" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">control structure statement in CSharp(C#)</h1>
    <div className="first">
        <a href="/csharp-string">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="m-4 mh2">Types of control structure statement in CSharp</h2>

    <p className="mt-4 para"> program is executed as per requirement according to requirement the sequence can be changed  by using the control structure statement .the categories and keywords  are given below:
</p>
    
<h2 className="mt-4 mh2">Conditional Statement is many types in C#:<br/></h2>

<h3 className="mt-4 mh3">If-condition <br/>
If-else<br/>
If-else-if<br/>
Nested if<br/>
Switch-case
</h3>
<h2 className="mt-4 mh2">c# looping (iteration)<br/></h2>
<h3 className="mt-4 mh3">There are 3 types of looping in c#:<br/>
</h3>
<h4 className="mt-4">While loop<br/>
Do-while loop<br/>
For loop<br/>
</h4>
<h2 className="mt-4 mh2">Jumping statements in c#:<br/></h2>
<h3 className="mt-4">C# Supports only three types of jumping statements in c#: 
<br/></h3>
<h4 className="mt-4">Control Structure<br/>
Continue<br/>
Goto
</h4>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-string">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Cscontrolstruct;